import { Button, Close, Palette } from '@sbt-web/ui';
import classnames from 'classnames';
import React from 'react';

import classes from './styles.module.scss';

interface Props {
  show?: boolean;
  onClose: () => void;
  onNotifyMe: () => void;
}

const SnackBarContent: React.FC<Props> = ({
  show = false,
  onClose,
  onNotifyMe,
}) => {
  return (
    <div
      className={classnames(classes['snackbar-wrapper'], {
        [classes['wrapper-visible']]: show,
      })}
    >
      <div className={classes.snackbar}>
        <p className={classnames('body-text', 'small', classes.invitation)}>
          Scopri quando vengono pubblicati <b>nuovi annunci</b>
        </p>

        <Button
          classes={[classes['notify-me']]}
          size="small"
          onClick={onNotifyMe}
          iconLeft={
            <img
              src="/static/img/ui/bell-small-off.svg"
              height="16"
              width="16"
              alt=""
              loading="lazy"
              decoding="async"
            />
          }
        >
          Avvisami
        </Button>
        <Button
          classes={[classes['snackbar-close']]}
          design="text"
          onClick={onClose}
          icon={
            <Close width={22} height={22} fillColor={Palette.NeutralGrey2} />
          }
        />
      </div>
    </div>
  );
};
SnackBarContent.displayName = 'SnackBarContent';

export default SnackBarContent;
